

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from "react-i18next";

//import api
import { getStaking } from "../../api/staking"

//import lib
import isEmpty from "../../lib/isEmpty";
import { truncateDecimals } from "../../lib/roundOf";

//import modal
import StakingModal from "./StakingModal";

const initialFormValue = {
    isModalOpen: false,
    record: {},
    type: "flexible"
};

const StakingList = () => {

    const { t, i18n } = useTranslation()


    //redux
    const walletData = useSelector((state) => state.wallet);
    const priceConversion = useSelector((state) => state.priceConversion);

    //statte
    const [tab, setTab] = useState("flexible");
    const [list, setList] = useState([]);
    const [stakeData, setStakeData] = useState(initialFormValue);
    const [filter, setFilter] = useState(true)
    const [loader, setLoading] = useState(true);


    //function
    const handleSubmit = (e) => {
        if (tab !== e) {
            setList([]);
            setLoading(true);
            setTab(e);
        }
    }

    const handleSearch = (e) => {
        let { name, value } = e.target;
        function getSearch(item) {
            return (
                item.coin.toLowerCase() == value?.toLowerCase()
            );
        }
        let filterDoc = list.filter(getSearch);
        if (!isEmpty(filterDoc)) {
            setFilter(true)
            setList(filterDoc);
        } else {
            setFilter(false)
        }

        if (isEmpty(value)) {
            setFilter(true)
            getStakeData();
        }
    };

    const getStakeData = async () => {
        let reqData = {
            type: tab
        }
        setLoading(true)
        const { status, result } = await getStaking(reqData)
        if (status === 'success') {
            // console.log(result, 'result')
            let tempArr = [...result];
            walletData?.length >= 0 &&
                walletData.map((item, index) => {
                    let pairIndex =
                        tempArr &&
                        tempArr.findIndex((el) => {
                            return el.currencyId == item._id;
                        });
                    if (pairIndex >= 0 && !isEmpty(pairIndex)) {
                        let PriceCnv = priceConversion.find(
                            (el) =>
                                el.baseSymbol == item.coin && el.convertSymbol == "USD"
                        );
                        tempArr[pairIndex] = {
                            ...tempArr[pairIndex],
                            ...{
                                stakeBal: parseFloat(item.stakeBal - item.lockedBal),
                                convertPrice: !isEmpty(PriceCnv?.convertPrice) ? parseFloat(PriceCnv.convertPrice) : 1,
                                USDValue: !isEmpty(PriceCnv?.convertPrice)
                                    ? parseFloat(item.stakeBal - item.lockedBal) *
                                    parseFloat(PriceCnv.convertPrice)
                                    : parseFloat(item.stakeBal - item.lockedBal)
                            },
                        };
                    }
                });
            setList(tempArr)
        }
        setLoading(false)
    }

    const handleCloseModal = () => {
        setStakeData({ isModalOpen: false, record: {}, type: "" });
    };

    useEffect(() => {
        getStakeData()
    }, [tab, walletData, priceConversion])


    return (
        <>
            <StakingModal
                isShow={stakeData.isModalOpen}
                record={stakeData.record}
                type={stakeData.type}
                onHide={handleCloseModal}
            />
            <div className="staking_top_flex">
                <div className="bg-[#f4f3f3] rounded inline-flex justify-start items-center overflow-hidden">
                    <button
                        className={`w-28 px-4 py-2 inline-flex flex-col justify-center items-center transition-colors border-0 ${tab == 'flexible' ? 'bg-[#395645] text-white' : 'bg-transparent text-gray-500 hover:text-[#395645]'}`}
                        onClick={() => handleSubmit("flexible")}
                    >
                        <div className="justify-center text-base font-normal font-['Roobert']">{t("FLEXIBLE")}</div>
                    </button>
                    <button
                        className={`w-28 px-4 py-2 inline-flex flex-col justify-center items-center transition-colors border-0 ${tab == 'fixed' ? 'bg-[#395645] text-white' : 'bg-transparent text-gray-500 hover:text-[#395645]'}`}
                        onClick={() => handleSubmit("fixed")}
                    >
                        <div className="justify-center text-base font-normal font-['Roobert']">{t("FIXED")}</div>
                    </button>
                </div>
                <div className="sm:w-52 w-full p-2 rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 inline-flex flex-col justify-start items-center gap-6">
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                        <div className=" relative overflow-hidden flex-shrink-0">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.334 11.334L14.0007 14.0007" stroke="#6B7280" stroke-width="1.5" stroke-linecap="square" />
                                <path d="M12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="square" />
                            </svg>
                        </div>
                        <input
                            type="text"
                            placeholder={t('SEARCH')}
                            onChange={handleSearch}
                            className="w-full bg-transparent border-none outline-none text-[#6B7280] text-[15px] font-normal font-['Roobert'] placeholder:text-[#6B7280]"
                        />
                    </div>
                </div>

            </div>

            <div className="tab-content" id="pills-tabContent">
                <div
                    className={`tab-pane fade ${tab === 'flexible' ? 'show active' : ''}`}
                    id="pills-flexible"
                    role="tabpanel"
                    aria-labelledby="pills-flexible-tab"
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4">
                        {list && list.length > 0 && list.map((item, i) => {
                            // console.log(item,'item')
                            if (filter) {
                                return (
                                    <div key={`flex-${i}`}>
                                        <div className="w-full h-full p-2 rounded outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 inline-flex flex-col justify-start items-start gap-2">
                                            <div className="self-stretch p-2 bg-[#f4f3f3] rounded-sm inline-flex justify-between items-center">
                                                <div className="inline-flex flex-col justify-start items-start gap-1">
                                                    <div className="justify-center text-[#3a4f66] text-sm font-normal font-['Roobert']">{item.coin}</div>
                                                    <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']"><CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item?.convertPrice, 6)} /></div>
                                                </div>
                                                <img className="w-9 h-9 object-contain" src={item.image} alt={item.coin} />
                                            </div>
                                            <div className="self-stretch flex flex-col justify-start items-start gap-1">
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#6B7280] text-xs font-normal font-['Roobert']">{t("AVAILABLE_BALANCE")}</div>
                                                    <div className="justify-center text-[#3a4f66] text-xs font-medium font-['Roobert']"><CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item?.stakeBal, 2)} /> {item.coin}</div>
                                                </div>
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#6B7280] text-xs font-normal font-['Roobert']">{t("AVAILABLE_BALANCE_USDT")}</div>
                                                    <div className="justify-center text-[#3a4f66] text-xs font-medium font-['Roobert']">$ {item?.USDValue ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item.USDValue, 2)} /> : 0}</div>
                                                </div>
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#395645] text-xs font-normal font-['Roobert']">{t("APY")}</div>
                                                    <div className="justify-center text-[#395645] text-xs font-normal font-['Roobert']">{item.flexibleAPY} %</div>
                                                </div>
                                            </div>
                                            <button
                                                className="primary_btn self-stretch h-9 group transition-colors"
                                                onClick={() => {
                                                    setStakeData({
                                                        isModalOpen: true,
                                                        record: item,
                                                        type: "flexible"
                                                    });
                                                }}
                                            >
                                                <div className="text-center group-hover:text-[#395645] justify-center text-[#f4f3f3] text-base font-medium font-['Roobert']">{t("HOME_BTN1")}</div>
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                        {(!loader && list && list.length == 0 || !filter) && <span className="col-span-full text-center">{t("THERE_NO_RECORD")}</span>}
                        {loader && (
                            <span className="col-span-full text-center inline-block mt-4 mb-4">
                                <i className="fas fa-spinner fa-spin"></i> {t("LOADING")}...
                            </span>
                        )}
                    </div>
                </div>
                <div
                className={`tab-pane fade ${tab === 'fixed' ? 'show active' : ''}`}
                    id="pills-fixed"
                    role="tabpanel"
                    aria-labelledby="pills-fixed-tab"
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5 gap-4">
                        {list && list.length > 0 && list.map((item, i) => {
                            let data = item.periodList.find((el) => el.days === '360')
                            if (filter) {
                                return (
                                    <div key={`fix-${i}`}>
                                        <div className="w-full h-full p-2 rounded outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 inline-flex flex-col justify-start items-start gap-2">
                                            <div className="self-stretch p-2 bg-[#f4f3f3] rounded-sm inline-flex justify-between items-center">
                                                <div className="inline-flex flex-col justify-start items-start gap-1">
                                                    <div className="justify-center text-[#3a4f66] text-sm font-normal font-['Roobert']">{item.coin}</div>
                                                    <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']"><CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item?.convertPrice, 6)} /></div>
                                                </div>
                                                <img className="w-9 h-9 object-contain" src={item.image} alt={item.coin} />
                                            </div>
                                            <div className="self-stretch flex flex-col justify-start items-start gap-1">
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#6B7280] text-xs font-normal font-['Roobert']">{t("AVAILABLE_BALANCE")}</div>
                                                    <div className="justify-center text-[#3a4f66] text-xs font-medium font-['Roobert']"><CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item?.stakeBal, 2)} /> {item.coin}</div>
                                                </div>
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#6B7280] text-xs font-normal font-['Roobert']">{t("AVAILABLE_BALANCE_USDT")}</div>
                                                    <div className="justify-center text-[#3a4f66] text-xs font-medium font-['Roobert']">$ {item?.USDValue ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(item?.USDValue, 2)} /> : 0}</div>
                                                </div>
                                                <div className="self-stretch inline-flex justify-between items-start">
                                                    <div className="justify-center text-[#395645] text-xs font-normal font-['Roobert']">{t("APY")}</div>
                                                    <div className="justify-center text-[#395645] text-xs font-normal font-['Roobert']">{data?.APY} %</div>
                                                </div>
                                            </div>
                                            <button
                                                className="primary_btn self-stretch h-9 group transition-colors"
                                                onClick={() => {
                                                    setStakeData({
                                                        isModalOpen: true,
                                                        record: item,
                                                        type: "fixed"
                                                    });
                                                }}
                                            >
                                                <div className="text-center group-hover:text-[#395645] justify-center text-[#f4f3f3] text-base font-medium font-['Roobert']">{t("HOME_BTN1")}</div>
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        })
                        }
                        {(!loader && list && list.length == 0 || !filter) && <span className="col-span-full text-center">{t("THERE_NO_RECORD")}</span>}
                        {loader && (
                            <span className="col-span-full text-center inline-block mt-4 mb-4">
                            <i className="fas fa-spinner fa-spin"></i>{t("LOADING")}...
                            </span>
                        )}
                    </div>
                </div>
            </div>

        </>
    )
}

export default StakingList;
